import "../Amc/TaskListing.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import nexticn from "../Components/Assets/svg/chevron-right-solid.svg";
import backicn from "../Components/Assets/svg/back-chevron-right-solid (1).svg";
import viewicn from "../Components/Assets/Our Levers/eye.png";
import active from "../Components/Assets/Admin-Assets/green-active.png";
import targetactive from "../Components/Assets/Admin-Assets/red-active.png";
import x from "../Components/Assets/Management/x-task.png";
import fb from "../Components/Assets/Management/fb-task.png";
import li from "../Components/Assets/Management/linkedin-task.png";
import insta from "../Components/Assets/Management/instagram-task.png";
import { formatFeedbackText } from "../utils/feedbackFormatter";
export function TaskListing() {
  const [companiesWithTasks, setCompaniesWithTasks] = useState([]);
  const scrollRefs = useRef({});
  const [showCompaniseTasks, setShowCompaniseTasks] = useState(true);
  const [showSelectedTaskWindow, setShowSelectedTaskWindow] = useState(false);
  const [showSelectedCompanyDetail, setShowSelectedCompanyDetail] =
    useState(false);
  const [selectedRolledBackTask, setSelectedRolledBackTask] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showTaskpreview, setShowTaskpreview] = useState(null);
  const [companyProfile, setCompanyProfile] = useState(null);
  const navigate = useNavigate();

  const fetchCompanyAllDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("You must be logged in to access this page.");
        navigate("/admin/login");
        return;
      }

      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/all-companies",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        console.log("Successfull fetch All Task Section-1");

        const companies = response.data;
        const filteredCompanies = companies.filter(
          (item) => item.tasks && item.tasks.length > 0
        );

        const priority = { Pending: 1, "Roll Back": 2, Approved: 3 };

        filteredCompanies.forEach((company) => {
          company.tasks.sort(
            (a, b) => priority[a.currentStatus] - priority[b.currentStatus]
          );
        });

        if (filteredCompanies.length > 0) {
          setCompaniesWithTasks(filteredCompanies);
        } else {
          toast.info("No company has tasks.");
        }
      } else {
        toast.error("Failed to fetch company profile");
      }
    } catch (error) {
      console.error("Error fetching company profile:", error);
      toast.error("An error occurred while fetching company details.");
      navigate("/admin/login");
    }
  };

  useEffect(() => {
    fetchCompanyAllDetails();
  }, []);

  const getStatusClass = (status) => {
    switch (status) {
      case "Approved":
        return {
          backgroundColor: " #5eb35eb7",
        };
      case "Pending":
        return {
          backgroundColor: " #ff9100",
        };
      case "Roll Back":
        return {
          backgroundColor: " #f54100",
        };
      case "Posted":
        return {
          backgroundColor: "rgb(128, 0, 255)",
        };
      default:
        return {};
    }
  };

  const scrollLeft = (companyId) => {
    const ref = scrollRefs.current[companyId];
    if (ref) {
      ref.scrollBy({ left: -260, behavior: "smooth" });
    }
  };

  const scrollRight = (companyId) => {
    const ref = scrollRefs.current[companyId];
    if (ref) {
      ref.scrollBy({ left: 260, behavior: "smooth" });
    }
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };
  function getDaysDifference(dateString) {
    if (!dateString) return "-";
    const today = new Date();
    const target = new Date(dateString);
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    const diffTime = target - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "Today";
    return diffDays > 0 ? `${diffDays} Days` : `${Math.abs(diffDays)} Days Ago`;
  }

  return (
    <div className="task-listing-container-page">
      {showCompaniseTasks && (
        <div className="task-listing-container">
          {companiesWithTasks.length > 0 ? (
            companiesWithTasks.map((companyData, index) => {
              const companyId = companyData.company._id;

              if (!scrollRefs.current[companyId]) {
                scrollRefs.current[companyId] = React.createRef();
              }

              return (
                <div className="cmpy-task-lister" key={companyId}>
                  <div className="cmpy-detail-row">
                    <ul>
                      <li>
                        {index + 1}.{" "}
                        <img
                          src={companyData.company.logo}
                          className="admin-cmpy-logo"
                          alt=""
                        />
                      </li>

                      <li className="l1">
                        <h2>Name:</h2>
                        <p>{companyData.company.companyName}</p>
                      </li>
                      <li className="l2">
                        <h2>Mobile No:</h2>
                        <p>{companyData.company.phone}</p>
                      </li>
                      <li className="l3">
                        <h2>Email:</h2> <p>{companyData.company.email}</p>
                      </li>
                      <li>
                        <h2>Tasks:</h2>
                        <p>{companyData.tasks.length}</p>
                      </li>
                      <li
                        onClick={() => {
                          setCompanyProfile(companyData.company);
                          setShowCompaniseTasks(false);
                          setShowSelectedCompanyDetail(true);
                        }}
                      >
                        View <img className="eye-icn" src={viewicn} alt="" />
                      </li>
                    </ul>
                  </div>
                  <div className="cmpy-task-row-container-navigation">
                    <img
                      src={backicn}
                      alt="Scroll Left"
                      className="assign-task-btn back"
                      onClick={
                        companyData.tasks.length > 4
                          ? () => scrollLeft(companyId)
                          : undefined
                      }
                      style={{
                        visibility:
                          companyData.tasks.length > 4 ? "visible" : "hidden",
                        pointerEvents:
                          companyData.tasks.length > 4 ? "auto" : "none",
                      }}
                    />
                    <div
                      className="cmpy-task-row-container"
                      ref={(el) => (scrollRefs.current[companyId] = el)}
                    >
                      {companyData.tasks.map((task) => (
                        <div
                          className="cmpy-task-row-box"
                          onClick={() => {
                            setSelectedRolledBackTask(task);
                            setShowCompaniseTasks(false);
                            setShowSelectedTaskWindow(true);
                            setPreviewUrl(null);
                            setSelectedFile(null);
                          }}
                          key={task._id}
                        >
                          <div className="cmpy-id-status">
                            <div className="cmpy-task-id">
                              <h5>TaskId: </h5>
                              <p>#{task.taskId}</p>
                            </div>
                            <div
                              className="status-card-text"
                              style={getStatusClass(task.currentStatus)}
                            >
                              {task.currentStatus}
                            </div>
                          </div>
                          <div className="cmpy-task-title">
                            <h5>Title: </h5>
                            <p className="overflow-control">{task.title}</p>
                          </div>
                          <div className="cmpy-task-review-date">
                            <h5>Review Date: </h5>
                            <p>
                              {new Date(
                                task.submissionForReview
                              ).toLocaleDateString()}
                            </p>
                          </div>
                          <div className="cmpy-task-review-date">
                            <h5>Target Date: </h5>
                            <p>
                              {new Date(
                                task.targetPostingDate
                              ).toLocaleDateString()}
                            </p>
                          </div>
                          <div className="total-days">
                            <div className="submission-days">
                              <img src={active} alt="" />
                              Submission:{" "}
                              <p>
                                {getDaysDifference(task.submissionForReview)}
                              </p>
                            </div>
                            <div className="target-days">
                              <img src={targetactive} alt="" />
                              Target:{" "}
                              <p>{getDaysDifference(task.targetPostingDate)}</p>
                            </div>
                          </div>
                          <div className="cmpy-task-view-btn-container">
                            <div
                              className="cmpy-task-view-btn"
                              onClick={() => {
                                setSelectedRolledBackTask(task);
                                setShowCompaniseTasks(false);
                                setShowSelectedTaskWindow(true);
                                setPreviewUrl(null);
                                setSelectedFile(null);
                              }}
                            >
                              View
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <img
                      src={nexticn}
                      alt="Scroll Right"
                      className="assign-task-btn next"
                      onClick={
                        companyData.tasks.length > 4
                          ? () => scrollRight(companyId)
                          : undefined
                      }
                      style={{
                        visibility:
                          companyData.tasks.length > 4 ? "visible" : "hidden",
                        pointerEvents:
                          companyData.tasks.length > 4 ? "auto" : "none",
                      }}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <div className="loader-container">
              <span className="loader"></span>
            </div>
          )}
        </div>
      )}

      {showSelectedTaskWindow && selectedRolledBackTask && (
        <div className="admin-show-task-status-container">
          <div className="close-button-row">
            <img
              onClick={() => {
                setShowSelectedTaskWindow(false);
                setShowCompaniseTasks(true);
                setSelectedRolledBackTask(null);
              }}
              width="48"
              height="48"
              src="https://img.icons8.com/fluency/48/delete-sign.png"
              alt="delete-sign"
              className="status-cross-symbol"
            />
          </div>

          <div className="status-top-floor">
            <div className="status-top-floor-row-1">
              <div className="status-col-1">
                <div className="status-row rm-padding">
                  <div className="status-task-id">
                    <div className="task-id">Task ID</div>
                    <div className="task-id-number">
                      #{selectedRolledBackTask.taskId}
                    </div>
                  </div>
                  <div
                    className="task-current-status"
                    style={getStatusClass(selectedRolledBackTask.currentStatus)}
                  >
                    {selectedRolledBackTask.currentStatus}
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">Task Title</div>
                    <div className="task-title-name-status task-h">
                      {selectedRolledBackTask.title}
                    </div>
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">Tagline or Slogan</div>
                    <div className="task-title-name-status task-h">
                      {selectedRolledBackTask.tagline}
                    </div>
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">Purpose/Objective</div>
                    <div className="task-title-name-status">
                      {selectedRolledBackTask.taskpurpose}
                    </div>
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">Main Headline</div>
                    <div className="task-title-name-status task-h">
                      {selectedRolledBackTask.headline}
                    </div>
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">
                      Key Offer or Message
                    </div>
                    <div className="task-title-name-status">
                      {selectedRolledBackTask.offerormessage}
                    </div>
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">
                      Call to Action (CTA)
                    </div>
                    <div className="task-title-name-status">
                      {selectedRolledBackTask.calltoaction}
                    </div>
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">Branding Guidelines</div>
                    <div className="task-title-name-status">
                      {selectedRolledBackTask.guidlines}
                    </div>
                  </div>
                  <div className="status-task-title">
                    <div className="task-title-status">
                      Additional Information
                    </div>
                    <div className="task-title-name-status">
                      {selectedRolledBackTask.additionalinfo}
                    </div>
                  </div>
                  <div className="status-task-des">
                    <div className="task-title-status">Task Description</div>
                    <div className="task-title-name-status">
                      {selectedRolledBackTask.description}
                    </div>
                  </div>
                  <div className="for-date-row">
                    <div className="status-task-dates">
                      <label className="task-title-status">Target Date</label>
                      <div className="status-target-date">
                        <input
                          type="date"
                          name="targetPostingDate"
                          value={formatDateForDisplay(
                            selectedRolledBackTask.targetPostingDate
                          )}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="status-task-dates">
                      <label className="task-title-status">Deadline Date</label>
                      <div className="status-deadline-date">
                        <input
                          type="date"
                          name="submissionForReview"
                          value={formatDateForDisplay(
                            selectedRolledBackTask.submissionForReview
                          )}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  <div className="platform-row-response">
                    <label className="new-task-date-label">
                      Selected Platforms has to Post:
                    </label>
                    <div className="social-checkbox">
                      {selectedRolledBackTask.platform_x && (
                        <img src={x} className="checkbox__textwrapper" />
                      )}
                      {selectedRolledBackTask.platform_fb && (
                        <img src={fb} className="checkbox__textwrapper" />
                      )}
                      {selectedRolledBackTask.platform_insta && (
                        <img src={insta} className="checkbox__textwrapper" />
                      )}
                      {selectedRolledBackTask.platform_li && (
                        <img src={li} className="checkbox__textwrapper" />
                      )}
                    </div>
                  </div>
                  {selectedRolledBackTask.referenceImage && (
                    <div className="info-group-img">
                      <label className="task-title-status">
                        Reference Image
                      </label>
                      <a
                        href={selectedRolledBackTask.referenceImage}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={selectedRolledBackTask.referenceImage}
                          alt="Brand Relate Image 6"
                          className="profile-logo"
                        />
                      </a>
                    </div>
                  )}
                </div>
              </div>

              {selectedRolledBackTask.currentStatus === "Roll Back" && (
                <>
                  {selectedRolledBackTask.rollbackFeedback.length > 0 && (
                    <div className="past-rollback">
                      <h3>Rollback Feedback</h3>
                      <ul>
                        {selectedRolledBackTask.rollbackFeedback.map(
                          (feedback, index) => (
                            <li key={index}>
                              {feedback.doneTaskImage && (
                                <div className="info-group-img">
                                  <a
                                    href={feedback.doneTaskImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <label
                                      htmlFor=""
                                      className="adim-roll-row-label"
                                    >
                                      Admin Given Image
                                      <img
                                        src={feedback.doneTaskImage}
                                        alt="Brand Relate Image 6"
                                        className="profile-logo"
                                      />
                                    </label>
                                  </a>
                                </div>
                              )}
                              {feedback.clientSuggestImage && (
                                <div className="info-group-img">
                                  <a
                                    href={feedback.clientSuggestImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <label
                                      htmlFor=""
                                      className="adim-roll-row-label"
                                    >
                                      User Suggest Image*
                                      <img
                                        src={feedback.clientSuggestImage}
                                        alt="Brand Relate Image 6"
                                        className="profile-logo"
                                      />
                                    </label>
                                  </a>
                                </div>
                              )}{" "}
                              {(feedback?.feedback ?? "").toString().trim()
                                .length > 0 && (
                                <div className="feed-index">
                                  {(() => {
                                    const displayCount =
                                      selectedRolledBackTask.rollbackFeedback.length;
                                    if (displayCount > 1) {
                                      return (
                                        <div className="feedback-number">
                                          {index + 1})
                                        </div>
                                      );
                                    }
                                    return null;
                                  })()}
                                  <div className="feedback-text">
                                    {formatFeedbackText(
                                      feedback.feedback,
                                      `tasklist-rollback-feedback-${index}`
                                    )}
                                  </div>
                                </div>
                              )}
                            </li>
                          )
                        )}
                      </ul>
                      {selectedRolledBackTask.doneTaskImage && (
                        <div className="task-preview-img-container">
                          <div className="status-title-preview">
                            Last Admin Uploaded Image
                          </div>
                          <img
                            src={selectedRolledBackTask.doneTaskImage}
                            className="yet-task-preview-img admin-img-btm"
                            alt="Task Preview"
                          />
                        </div>
                      )}
                    </div>
                  )}
                  <div className="admin-upload-image">
                    <label htmlFor="referenceimage">Upload Task Image:</label>
                    <input
                      type="file"
                      name="adminuploadtaskimage"
                      className="img-input admin-input"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setSelectedFile(file);
                        if (file) {
                          const preview = URL.createObjectURL(file);
                          setPreviewUrl(preview);
                        }
                      }}
                    />
                    <button
                      className="button-uploade"
                      disabled={!selectedFile || isUploading}
                      onClick={async () => {
                        if (!selectedRolledBackTask || !selectedFile) return;

                        const formData = new FormData();
                        formData.append("image", selectedFile);

                        try {
                          setIsUploading(true);
                          const token = localStorage.getItem("token");

                          const response = await axios.post(
                            `${process.env.REACT_APP_API_URL}/admin/upload-task-image/${selectedRolledBackTask._id}`,
                            formData,
                            {
                              headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: `Bearer ${token}`,
                              },
                            }
                          );

                          if (response.status === 200) {
                            toast.success("Task image uploaded successfully", {
                              autoClose: 500,
                            });
                            setShowTaskpreview(true);
                            setSelectedRolledBackTask((prev) => ({
                              ...prev,
                              referenceImage: response.data.task.image,
                            }));
                            setSelectedFile(null);
                          } else {
                            setShowTaskpreview(false);
                            toast.error("Image upload failed");
                          }
                        } catch (err) {
                          toast.error("Error uploading image: " + err.message);
                        } finally {
                          setIsUploading(false);
                        }
                      }}
                    >
                      <span className="text">
                        {isUploading ? "Uploading..." : "Upload"}
                      </span>
                    </button>
                  </div>
                  <div className="status-col-2">
                    {previewUrl && (
                      <img
                        src={previewUrl}
                        className="yet-task-preview-img"
                        alt="Task Preview"
                      />
                    )}
                  </div>
                </>
              )}

              {selectedRolledBackTask.currentStatus === "Approved" && (
                <>
                  {selectedRolledBackTask.rollbackFeedback.length > 0 && (
                    <div className="past-rollback">
                      <h3>Rollback Feedback</h3>
                      <ul>
                        {selectedRolledBackTask.rollbackFeedback.map(
                          (feedback, index) => (
                            <li key={index}>
                              {feedback.doneTaskImage && (
                                <div className="info-group-img">
                                  <a
                                    href={feedback.doneTaskImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={feedback.doneTaskImage}
                                      alt="Brand Relate Image 6"
                                      className="profile-logo"
                                    />
                                  </a>
                                </div>
                              )}
                              {(feedback?.feedback ?? "").toString().trim()
                                .length > 0 && (
                                <div className="feed-index">
                                  {(() => {
                                    const displayCount =
                                      selectedRolledBackTask.rollbackFeedback.length;
                                    if (displayCount > 1) {
                                      return (
                                        <div className="feedback-number">
                                          {index + 1})
                                        </div>
                                      );
                                    }
                                    return null;
                                  })()}
                                  <div className="feedback-text">
                                    {formatFeedbackText(
                                      feedback.feedback,
                                      `tasklist-approved-feedback-${index}`
                                    )}
                                  </div>
                                </div>
                              )}
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  )}
                  <div className="task-preview-img-container">
                    <div className="status-title-preview">
                      Approved Task Image
                    </div>
                    <img
                      src={selectedRolledBackTask.doneTaskImage}
                      className="yet-task-preview-img admin-img-btm"
                      alt="Task Preview"
                    />
                  </div>
                </>
              )}

              {selectedRolledBackTask.currentStatus === "Pending" && (
                <>
                  {selectedRolledBackTask.rollbackFeedback.length > 0 && (
                    <div className="admin-past-rollback">
                      <h3>Rollback Feedback</h3>
                      <ul>
                        {selectedRolledBackTask.rollbackFeedback.map(
                          (feedback, index) => (
                            <li key={index}>
                              <div className="feed-index">
                                {(() => {
                                  const displayCount =
                                    selectedRolledBackTask.rollbackFeedback.length;
                                  if (displayCount > 1) {
                                    return (
                                      <div className="feedback-number">
                                        {index + 1})
                                      </div>
                                    );
                                  }
                                  return null;
                                })()}
                                <div className="feedback-text">
                                  {formatFeedbackText(
                                    feedback.feedback,
                                    `tasklist-pending-feedback-${index}`
                                  )}
                                </div>
                              </div>
                            </li>
                          )
                        )}
                      </ul>
                      <div className="task-preview-img-container">
                        <img
                          src={selectedRolledBackTask.doneTaskImage}
                          className="yet-task-preview-img admin-img-btm"
                          alt="Task Preview"
                        />
                      </div>
                    </div>
                  )}
                  {selectedRolledBackTask.doneTaskImage && (
                    <div className="task-preview-img-container">
                      <div className="status-title-preview">
                        Last Admin Uploaded Image
                      </div>
                      <img
                        src={selectedRolledBackTask.doneTaskImage}
                        className="yet-task-preview-img admin-img-btm"
                        alt="Task Preview"
                      />
                    </div>
                  )}
                  <div className="admin-upload-image">
                    <label htmlFor="referenceimage">Upload Task Image:</label>
                    <input
                      type="file"
                      name="adminuploadtaskimage"
                      className="img-input admin-input"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setSelectedFile(file);
                        if (file) {
                          const preview = URL.createObjectURL(file);
                          setPreviewUrl(preview);
                        }
                      }}
                    />
                    <button
                      className="button-uploade"
                      disabled={!selectedFile || isUploading}
                      onClick={async () => {
                        if (!selectedRolledBackTask || !selectedFile) return;

                        const formData = new FormData();
                        formData.append("image", selectedFile);

                        try {
                          setIsUploading(true);
                          const token = localStorage.getItem("token");

                          const response = await axios.post(
                            `${process.env.REACT_APP_API_URL}/admin/upload-task-image/${selectedRolledBackTask._id}`,
                            formData,
                            {
                              headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: `Bearer ${token}`,
                              },
                            }
                          );

                          if (response.status === 200) {
                            toast.success("Task image uploaded successfully", {
                              autoClose: 500,
                            });
                            setShowTaskpreview(true);
                            setSelectedRolledBackTask((prev) => ({
                              ...prev,
                              referenceImage: response.data.task.image,
                            }));
                            setSelectedFile(null);
                          } else {
                            setShowTaskpreview(false);
                            toast.error("Image upload failed");
                          }
                        } catch (err) {
                          toast.error("Error uploading image: " + err.message);
                        } finally {
                          setIsUploading(false);
                        }
                      }}
                    >
                      <span className="text">
                        {isUploading ? "Uploading..." : "Upload"}
                      </span>
                    </button>
                  </div>
                  <div className="status-col-2">
                    {previewUrl && (
                      <img
                        src={previewUrl}
                        className="yet-task-preview-img"
                        alt="Task Preview"
                      />
                    )}
                  </div>
                </>
              )}

              {selectedRolledBackTask.currentStatus === "Posted" && (
                <>
                  {selectedRolledBackTask.rollbackFeedback.length > 0 && (
                    <div className="past-rollback">
                      <h3>Rollback Feedback</h3>
                      <ul>
                        {selectedRolledBackTask.rollbackFeedback.map(
                          (feedback, index) => (
                            <li key={index}>
                              {feedback.doneTaskImage && (
                                <div className="info-group-img">
                                  <a
                                    href={feedback.doneTaskImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={feedback.doneTaskImage}
                                      alt="Brand Relate Image 6"
                                      className="profile-logo"
                                    />
                                  </a>
                                </div>
                              )}
                              {(feedback?.feedback ?? "").toString().trim()
                                .length > 0 && (
                                <div className="feed-index">
                                  {(() => {
                                    const displayCount =
                                      selectedRolledBackTask.rollbackFeedback.length;
                                    if (displayCount > 1) {
                                      return (
                                        <div className="feedback-number">
                                          {index + 1})
                                        </div>
                                      );
                                    }
                                    return null;
                                  })()}
                                  <div className="feedback-text">
                                    {formatFeedbackText(
                                      feedback.feedback,
                                      `tasklist-posted-feedback-${index}`
                                    )}
                                  </div>
                                </div>
                              )}
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  )}
                  <div className="status-col-2">
                    {selectedRolledBackTask.doneTaskImage && (
                      <div className="task-preview-img-container">
                        <div className="status-title-preview">Posted Image</div>
                        <img
                          src={selectedRolledBackTask.doneTaskImage}
                          className="yet-task-preview-img admin-img-btm"
                          alt="Check Code"
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {showSelectedCompanyDetail && (
        <div className="admin-company-details-view ">
          <div className="close-button-row">
            <img
              onClick={() => {
                setShowCompaniseTasks(true);
                setShowSelectedTaskWindow(false);
                setShowSelectedCompanyDetail(false);
              }}
              width="48"
              height="48"
              src="https://img.icons8.com/fluency/48/delete-sign.png"
              alt="delete-sign"
              className="status-cross-symbol"
            />
          </div>
          <div className="admin-alt-gap">
            <img
              src={companyProfile.logo}
              alt={companyProfile.companyName}
              className="profile-logo"
            />
            <div className="info-group">
              <h3>Company Name</h3>
              <p>{companyProfile.companyName || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Doing Business As (DBA)</h3>
              <p>{companyProfile.dba || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Federal Tax ID</h3>
              <p>{companyProfile.fedraltaxid || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Industry</h3>
              <p>{companyProfile.industry || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Email</h3>
              <p>{companyProfile.email || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Phone</h3>
              <p>{companyProfile.phone || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Website</h3>
              <p>{companyProfile.website || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Address Line 1</h3>
              <p>{companyProfile.address1 || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Address Line 2</h3>
              <p>{companyProfile.address2 || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>City</h3>
              <p>{companyProfile.city || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>State</h3>
              <p>{companyProfile.state || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>ZIP Code</h3>
              <p>{companyProfile.zip || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Country</h3>
              <p>{companyProfile.country || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>LinkedIn</h3>
              <p className="view-social-link">
                {companyProfile.linkedin || "N/A"}
              </p>
            </div>
            <div className="info-group">
              <h3>Facebook</h3>
              <p className="view-social-link">
                {companyProfile.facebook || "N/A"}
              </p>
            </div>
            <div className="info-group">
              <h3>Instagram</h3>
              <p className="view-social-link">
                {companyProfile.insta || "N/A"}
              </p>
            </div>
            <div className="info-group">
              <h3>X (Twitter)</h3>
              <p className="view-social-link">{companyProfile.x || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>YouTube</h3>
              <p className="view-social-link">
                {companyProfile.youtube || "N/A"}
              </p>
            </div>
            <div className="info-group">
              <h3>Font Family</h3>
              <p>{companyProfile.fontfamily || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Primary Color</h3>
              <p
                style={{
                  backgroundColor: companyProfile.color1 || "#ffffff",
                  borderRadius: "3px",
                  padding: "5px",
                }}
              >
                {companyProfile.color1 || "N/A"}
              </p>
            </div>
            <div className="info-group">
              <h3>Secondary Color</h3>
              <p
                style={{
                  backgroundColor: companyProfile.color2 || "#ffffff",
                  borderRadius: "3px",
                  padding: "5px",
                }}
              >
                {companyProfile.color2 || "N/A"}
              </p>
            </div>
            <div className="info-group">
              <h3>Tertiary Color</h3>
              <p
                style={{
                  backgroundColor: companyProfile.color3 || "#ffffff",
                  borderRadius: "3px",
                  padding: "5px",
                }}
              >
                {companyProfile.color3 || "N/A"}
              </p>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={true}
        transition={Zoom}
      />
    </div>
  );
}
